import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { getCustomerVehicle } from '../../services/userServices'
import { RootState } from '../../store/store'

interface VehicleImage {
  file_name: string
  file_path: string
}

export interface CustomerVehicle {
  customer_vehicleid: number
  company_name: string
  contact_person: string
  contact_number: string
  purchase_date: string
  vehicle_category: string | null
  image: VehicleImage[]
  vehicle_cat_id: number
  vehicle_subcatid: number
  modelid: number
  model_name: string
  vehicle_cat_name: string
  vehicle_subcat_name: string
  customerid: number
  AMC_status: any
  invoiceno: string
  vehicle_invoice_amount?: number | string
  free_service_expiry?: string
  free_service_status?: string
  package_name?: string
  amc_id?: number
  amc_year?: number
  package_id?: number
  amc_start_date?: string
  amc_expiry_date?: string
}

// State type for the Redux slice
interface UserState {
  loading: boolean
  data: CustomerVehicle[]
  error: string | undefined
}

// Initial state for the Redux slice
const initialState: UserState = {
  loading: false,
  data: [],
  error: undefined
}

// Create a Redux slice
export const customerVehicleSlice = createSlice({
  name: 'customerVehicle',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomerVehicle.pending, (state) => {
      state.loading = true
      state.error = undefined
    })

    builder.addCase(
      getCustomerVehicle.fulfilled,
      (state, action: PayloadAction<CustomerVehicle[]>) => {
        state.loading = false
        state.data = action.payload
      }
    )

    builder.addCase(getCustomerVehicle.rejected, (state, action) => {
      state.loading = false
      state.data = []
      state.error = action.error.message
    })
  }
})

// Selector
export const customerVehicleSelector = (
  state: RootState
): UserState => state.customerVehicleReducer

export default customerVehicleSlice.reducer